import { relations } from 'drizzle-orm';
import { boolean, index, integer, jsonb, pgTable, timestamp, varchar } from 'drizzle-orm/pg-core';
import { typeIdDataType as typeId } from '../utils/typeid';
import type { account, Provider } from './account';
import { application } from './application';
import { proxy } from './proxy';
import { accountScope } from './scope';

export const authIntent = pgTable(
  'auth_intent',
  {
    id: typeId('account', 'id').primaryKey().notNull(),
    data: jsonb().notNull().default('{}').$type<Record<string, unknown>>(),
    provider: varchar({ length: 255 }).notNull().$type<Provider>(),
    application_id: integer().references(() => application.id, { onDelete: 'cascade' }),
    account_scope_id: integer().references(() => accountScope.id, { onDelete: 'cascade' }),
    expires_at: timestamp({ withTimezone: true, mode: 'string' }).notNull(),
    proxy_id: integer().references(() => proxy.id),
    options: jsonb().notNull().default('{}').$type<{
      state?: string;
      auto_proxy_country?: string;
      initial_sync_enabled?: boolean;
      metadata?: (typeof account.$inferSelect)['metadata'];
      allow_country_fallback?: boolean;
      products_connection_status?: (typeof account.$inferSelect)['metadata']['products_connection_status'];
    }>(),
    is_reconnecting: boolean().notNull(),
  },
  (t) => [
    index('auth_intent_application_id_idx').on(t.application_id),
    index('auth_intent_account_scope_id_idx').on(t.account_scope_id),
  ],
);

export const authIntentsRelations = relations(authIntent, ({ one }) => ({
  proxy: one(proxy, { fields: [authIntent.proxy_id], references: [proxy.id] }),
  application: one(application, { fields: [authIntent.application_id], references: [application.id] }),
  accountScope: one(accountScope, { fields: [authIntent.account_scope_id], references: [accountScope.id] }),
}));
